export default {
  initialColorModeName: "light",
  colors: {
    body: "#fff",
    katanaLogo: "#000",
    githubIconFill: "#000",
    katanaBlogText: "#000",
    bioParagraph: "#545454",
    postPreviewBackground: "#fff",
    postBody: "#000",
    postDateColor: "#3f3f3f",
    postBorderColor: "#AFAFAF",
    tagBody: "#E8E8E8",
    tagTextColor: "#333",
    tagBackgroundHoverColor: "#1D282E",
    tagTextHoverColor: "#fff",
    arrowColor: "#000",
    articlePageBodyColor: "#fff",
    articleBodyColor: "#fff",
    articleTextColor: "#000",
    articleBorderColor: "#afafaf",
    clapIconFill: "#C8C7C7",
    clapIconBorder: "#62A0CD",
    modes: {
      dark: {
        body: "#334149",
        katanaLogo: "#fff",
        githubIconFill: "#fff",
        katanaBlogText: "#fff",
        bioParagraph: "#fff",
        postPreviewBackground: "#1D282E",
        postBody: "#fff",
        postDateColor: "#fff",
        postBorderColor: "#1D282E",
        tagBody: "#334149",
        tagTextColor: "#fff",
        tagBackgroundHoverColor: "#fff",
        tagTextHoverColor: "#1D282E",
        arrowColor: "#fff",
        articlePageBodyColor: "#334149",
        articleBodyColor: "#1D282E",
        articleTextColor: "#fff",
        articleBorderColor: "#333",
        clapIconFill: "#ffffff",
    clapIconBorder: "#62A0CD",
      },
    },
  },
}
